import { ObjectUtil } from '@ddt-web/generic-utils';

const DEFAULT_CHART_CONFIG: any = {
	chart: {
		spacing: 0,
		marginTop: 5,
		backgroundColor: null,
		style: {
			fontFamily: '"FortBook", Arial, sans-serif'
		}
	},
	credits: {
		enabled: false
	},
	exporting: {
		chartOptions: {
			chart: {
				backgroundColor: '#fff'
			}
		}
	},
	legend: {
		enabled: false
	},
	navigation: {
		buttonOptions: {
			enabled: false
		}
	},
	navigator: {
		enabled: false
	},
	plotOptions: {
		line: {
			marker: {
				enabled: false
			}
		},
		bubble: {
			maxSize: 25
		}
	},
	scrollbar: {
		enabled: false
	},
	title: {
		text: null
	},
	tooltip: {
		backgroundColor: '#f9f9f9',
		borderColor: '#a5a5a5',
		borderRadius: 0,
		padding: 15,
		shadow: false,
		useHTML: true,
		style: {
			fontFamily: '"FortBook", Arial, sans-serif'
		}
	}
};

export class DefaultChartConfig {
	public configuration: any;

	constructor(
		protected type: string,
		protected container: HTMLElement,
		protected colors?: Array<string>,
		protected height?: number,
		protected width?: number,
		protected title?: string,
		protected hideTitle?: boolean
	) {
		this.configuration = ObjectUtil.extend(DEFAULT_CHART_CONFIG, {
			chart: {
				height: height || container.offsetHeight,
				width: width || container.offsetWidth,
				type: type,
				renderTo: container
			},
			colors: colors,
			title: {
				text: !hideTitle ? title : null
			}
		});
	}
}
